import { createAsyncThunk } from '@reduxjs/toolkit';

import { handleListFetch } from '../apiHelpers';
import { RequestParamsBase } from '../Models/CommonRequestModels';

import { APISuiteDelete, APISuiteGet, APISuiteGetList, APISuitePost, APISuitePut } from './ApplicationSuites.api';

export const fetchApplicationSuites = createAsyncThunk('applicationSuites/fetchApplicationSuites', async (params?: RequestParamsBase) => {
    const response = await APISuiteGetList(params);
    return response.data;
});

export const deleteApplicationSuite = createAsyncThunk('applicationSuites/deleteApplicationSuite', async (id: string) => {
    const response = await APISuiteDelete({ id });
    const rows =  await handleListFetch(APISuiteGetList({}));
    return {
        id,
        response,
        rows
    };
});

export const putApplicationSuite = createAsyncThunk('applicationSuites/putApplicationSuite', async (item: { id:string, name:string }) => {
    const response = await APISuitePut(item);
    const rows = await handleListFetch(APISuiteGetList({}));
    return {
        item,
        response,
        rows
    };
});

export const postApplicationSuite = createAsyncThunk('applicationSuites/postApplicationSuite', async (item: { name:string }) => {
    const response = await APISuitePost(item);
    return {
        item,
        response
    };
});

export const fetchApplicationSuite = createAsyncThunk('applicationSuiteDetails/fetchDetails', async (id: string) => {
    const response = await APISuiteGet({ id });
    return response.data;
});
